import { Controller } from 'stimulus';
import preloadImage from '../helpers/preloadImage';

class PageHeaderController extends Controller {
  connect() {
    if (this.hasImageTarget) {
      this.loadImage()
        .then(() => {
          this.imageTarget.src = this.imageTarget.getAttribute('data-src');
          this.imageTarget.srcset = this.imageTarget.getAttribute('data-srcset');
        });
    }
  }

  loadImage() {
    return preloadImage(this.imageTarget);
  }
}

PageHeaderController.targets = [
  'image',
];

export default PageHeaderController;
